import script from "./ReserveCarView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReserveCarView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__